import { message, Popconfirm } from 'antd';
import React from 'react';
import { useDispatch } from 'react-redux';
import { deleteConfiguration } from '../../../redux/Configuration/actions';

const DeleteConfigButton = ({ _id }) => {
  const dispatch = useDispatch();

  const deleteEvent_fun = () => {
    dispatch(deleteConfiguration(_id));
    message.success("Deleted");
  };

  const confirm = () => {
    deleteEvent_fun();
  };

  const cancel = () => {
    // Handle cancel action if needed
  };

  return (
    <Popconfirm
      onConfirm={confirm}
      onCancel={cancel}
      title="Are you sure you want to delete?"
      okText="Yes"
      cancelText="No"
    >
      <a>Delete</a>
    </Popconfirm>
  );
};

export default DeleteConfigButton;
